var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Editor } from "@tinymce/tinymce-react";
/**
 * Maps a TemplateMenu into an appropriate format for the tinyMce Editor
 *
 * @param {TemplateMenu[]} menus - The Template Menus to display in the dropdown
 * @param {*} editor - TinyMCE editor object provided via the init.setup function.
 */
const mapMenu = (menus, editor, addDollarSignToVariables) => menus.map((menu) => {
    // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'TemplateMenuItem'.
    if (menu.value) {
        const menuLeaf = menu; // Save value for flow type refinement
        return {
            onAction: () => {
                // @ts-expect-error - TS2339 - Property 'link' does not exist on type 'TemplateMenuItem'.
                if (menuLeaf.link) {
                    const link = `${addDollarSignToVariables ? "$" : ""}{${
                    // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'TemplateMenuItem'.
                    menuLeaf.value}}`;
                    editor.execCommand("mceInsertRawHTML", false, 
                    // @ts-expect-error - TS2339 - Property 'link' does not exist on type 'TemplateMenuItem'.
                    `<a target="_blank" rel="noopener noreferrer" href="${link}">${menuLeaf.link.linkText}</a>`);
                }
                else {
                    editor.execCommand("mceInsertContent", false, 
                    // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'TemplateMenuItem'.
                    `${addDollarSignToVariables ? "$" : ""}{${menuLeaf.value}}`);
                }
            },
            type: "menuitem",
            text: menuLeaf.text,
        };
    }
    return {
        type: "nestedmenuitem",
        text: menu.text,
        getSubmenuItems: () => mapMenu(
        // $FlowFixMe  we can be sure this is a TemplateMenuParent
        // @ts-expect-error - TS2339 - Property 'menus' does not exist on type 'TemplateMenuItem'.
        menu.menus, editor),
    };
});
const defaultEditorOptions = {
    plugins: ["advlist autolink lists link placeholder paste emoticons"],
    target_list: false,
    relative_urls: 0,
    convert_urls: 0,
    contextmenu: false,
    remove_script_host: 0,
    paste_auto_cleanup_on_paste: true,
    paste_convert_middot_lists: false,
    paste_text_sticky: true,
    paste_strip_class_attributes: "all",
    paste_remove_styles: true,
    paste_remove_spans: true,
    paste_block_drop: true,
    paste_as_text: true,
    extended_valid_elements: "a[name|href|target=_blank|title]",
    browser_spellcheck: true,
    menubar: false,
    resize: false,
    statusbar: false,
    width: "100%",
    height: "300px",
    formats: {
        personalization: {
            inline: "span",
            attributes: {
                class: "message-template-personalization-icon",
            },
        },
    },
};
const defaultToolBar = "personalization | emoticons | bold italic underline | bullist numlist | link | alignleft aligncenter alignright";
const TinyMCEEditor = (props) => {
    const { menus } = props, otherProps = __rest(props, ["menus"]);
    let initObject = defaultEditorOptions;
    // Add setup function if menus are defined.
    if (menus) {
        initObject = Object.assign(Object.assign({}, defaultEditorOptions), { 
            // @ts-expect-error - TS2322 - Type '{ setup: (editor: any) => void; plugins: readonly ["advlist autolink lists link placeholder paste emoticons"]; target_list: false; relative_urls: 0; convert_urls: 0; contextmenu: false; remove_script_host: 0; ... 15 more ...; formats: { ...; }; }' is not assignable to type '{ readonly plugins: readonly ["advlist autolink lists link placeholder paste emoticons"]; readonly target_list: false; readonly relative_urls: 0; readonly convert_urls: 0; readonly contextmenu: false; ... 16 more ...; readonly formats: { ...; }; }'. | TS7006 - Parameter 'editor' implicitly has an 'any' type.
            setup: (editor) => {
                editor.ui.registry.addMenuButton("personalization", {
                    text: "Field",
                    // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
                    fetch: (callback) => callback(mapMenu(menus, editor, props.addDollarSignToVariables)),
                });
            } });
    }
    return (_jsx(Editor, Object.assign({}, otherProps, { 
        // @ts-expect-error - TS2322 - Type '{ readonly plugins: readonly ["advlist autolink lists link placeholder paste emoticons"]; readonly target_list: false; readonly relative_urls: 0; readonly convert_urls: 0; readonly contextmenu: false; ... 16 more ...; readonly formats: { ...; }; }' is not assignable to type 'RawEditorSettings & { selector?: undefined; target?: undefined; }'.
        init: initObject, toolbar: props.toolbar || defaultToolBar })));
};
export default TinyMCEEditor;
